import { Component, OnInit,HostListener } from '@angular/core';
import { ProgressbarComponent } from '../progressbar/progressbar.component';
import { HttpEventType,HttpResponse,HttpRequest,HttpClient } from '@angular/common/http';
import { Router,RouterModule} from '@angular/router';
import {
  CommonUtility, ComponentSummary, EmploymentPlanSummary, Components, WpPerson, EDIT_BTN, AgGridUtility,
  EmploymentPlan, PRINT_BTN,DELETE_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE,DataService,
  AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, EmploymentPlanCorVo, ComponentInfoVo
} from '../shared';
import { DateUtility, ServerConstantsService, TRIPLE_ROW_HEADER } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import * as $ from 'jquery';
import { GridOptions } from "ag-grid/main";

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(event.target.id == 'myModal'){
      var modal = document.getElementById("myModal");
      modal.style.display = "none";
    }
  }
  serverConstants:any;
  fileToUpload: File = null;
  filestoUpload=[];
  private gridOptions: GridOptions;
  private gridApi;
  private uploadgridApi;
  private gridColumnApi;
  private uploadgridColumnApi;
  public context;
  public frameworkComponents;
  selectedType:any = 'Employment Plan';
  uploadSwitch:any = 'No';
  defaultColDef = { resizable: true, cellStyle:{'font-size':'13px'} };
  columnDefs = [
    {headerName: 'Document ID', field: 'id' },
    {headerName: 'Document Type', field: 'doc_type' },
    {headerName: 'Uploaded Date', field: 'uploaded_dt'},
    {headerName: 'Uploaded By', field: 'uploaded_by'},
    {headerName: 'Action', field: 'path',cellRenderer: this.getEditButton}
];
uploadcolumnDefs = [
  {headerName: 'File Name', field: 'name' },
  {headerName: 'Size', field: 'size' },
  {headerName: 'Progress', field: 'progress',cellRenderer:'progressrenderer'},
];
filedetails = [];
deleteData:any;

rowData = [];
  constructor(public toastService:NotificationsService,public http:HttpClient,  public router:Router, public dataService:DataService, public serverConstantsService:ServerConstantsService) {
    this.serverConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('CORPN') === undefined) {
      this.router.navigate(['/task']);
    }
   }

  ngOnInit() {
    this.context = {
      component: this,
    };
    this.frameworkComponents = {
      progressrenderer:ProgressbarComponent
    };
    this.gridOptions = <GridOptions>{};
    this.load();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
    //this.gridOptions.rowClass = 'rm-grid-row';
    //this.gridApi.setDomLayout("autoHeight");
  }
  onuploadGridReady(params) {
    this.uploadgridApi = params.api;
    this.uploadgridColumnApi = params.columnApi;
    //this.uploadgridApi.sizeColumnsToFit();
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
    //this.uploadgridApi.setDomLayout("autoHeight");
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    let blob = this.fileToUpload;
    let fileReader = new FileReader();
    fileReader.onloadend = function(e:any) {
      //const that = params.context.component;
      var arr = (new Uint8Array(<ArrayBuffer> e.target.result)).subarray(0, 4);
      var header = "";
      for(var i = 0; i < arr.length; i++) {
         header += arr[i].toString(16);
      };
      if(['FFD8','8950','2550','D0CF','ffd8'].indexOf(header.substring(0,4)) > -1){
        localStorage.setItem('fileValidationUP','true');
      }
      else{
        localStorage.setItem('fileValidationUP','false');
      }
    };
    fileReader.readAsArrayBuffer(blob);
    setTimeout(()=>{
      if(((this.fileToUpload.size/1024)/1024) > 5){
        this.toastService.error("File size exceeds maximum limit","My Documents");
      }
      
      else if(localStorage.getItem('fileValidationUP') === 'true'){
        this.filestoUpload.push(this.fileToUpload);
        let uploaded = null;
        if(this.dataService.getSharedDataObject().get('firstName') != undefined && this.dataService.getSharedDataObject().get('firstName') != null){
          uploaded = this.dataService.getSharedDataObject().get('firstName') + this.dataService.getSharedDataObject().get('lastName');
        };
        let file={
          name:this.fileToUpload.name,
          uploaded_dt:(new Date().getMonth()+1) + '/'+new Date().getDate() + '/' + new Date().getFullYear(),
          size:((this.fileToUpload.size/1024)/1024).toFixed(2)+'MB',
          progress:0,
          doc_type:this.selectedType,
          uploaded_by:uploaded,
          person_id:this.dataService.getSharedDataObject().get('wpPersonId')
        }
        this.filedetails.push(file);
        console.log(this.filedetails);       
        this.uploadgridApi.setRowData(this.filedetails);
      }
      else{
        console.log("inside else ===");
        this.toastService.error("File type is not supported to upload","My Documents");
      }
    },1000);
    
}
upload(){
  let formData = new FormData();
  if(this.filestoUpload.length == 0){
    this.toastService.error("No files selected to upload", "My Documents");
  }
  else{
    for(let i =0; i < this.filestoUpload.length; i++){
      formData.append("files", this.filestoUpload[i], this.filestoUpload[i]['name']);
    }
    const req = new HttpRequest('POST', this.serverConstants.CITIZEN_API_URL+ '/fileUpload', formData, {
      reportProgress: true,
    });
    this.http.request(req).subscribe(event => {
      // Via this API, you get access to the raw event stream.
      // Look for upload progress events.
      if (event.type === HttpEventType.UploadProgress) {
        // This is an upload progress event. Compute and show the % done:
        const percentDone = Math.round(100 * event.loaded / event.total);
        this.filedetails.forEach((element)=>{
          element.progress = percentDone;
        })        
        this.uploadgridApi.setRowData(this.filedetails);
      } else if (event instanceof HttpResponse) {
        this.filestoUpload = [];
        this.save(event);
        //this.toastService.success("Succesfully uploaded file","My Documents");
      }
    },error=>{
      this.toastService.error("'Record not saved: Please review or contact Help Desk", "My Documents");
    });
  }
}
save(event){
  event.body["data"].forEach((element)=>{
    this.filedetails.forEach((element2)=>{
      if((element.originalname == element2.name)&& (element2.size == (((element.size/1024)/1024).toFixed(2)+'MB'))){
        element2.path = element.filename;
      }
    })
  });
  this.filedetails.forEach((element)=>{
    this.http.post(this.serverConstants.CITIZEN_API_URL+'/documents/save',element).subscribe((data)=>{
      if(data["message"] == 'success'){
        this.toastService.success("File saved successfully","My Documents");
        this.filedetails = this.filedetails.filter(function( obj ) {
          return ((obj.name !== element.name) && (obj.size != element.size));
        });        
        this.uploadgridApi.setRowData(this.filedetails);
      }
      else{
        this.toastService.error("'Record not saved: Please review or contact Help Desk", "My Documents");
      }
    },error=>{
      this.toastService.error("'Record not saved: Please review or contact Help Desk", "My Documents");
    })
  });
  this.load();
}
load(){
  let request = {
    perId:this.dataService.getSharedDataObject().get('wpPersonId'),
    type:'UP'
  };
  this.http.post(this.serverConstants.CITIZEN_API_URL+'/documents/load',request).subscribe((data:Array<Object>)=>{    
    this.rowData = data;    
  },error=>{
    this.toastService.error("Unable to load files", "My Documents");
  })
}
getEditButton(params) {
  const that = params.context.component;
  /*const status = params.data.statusCd;
  if (status === 'CO') {
    that.dataService.addValueToSharedDataMap("assessment-read-only", true);
  }*/



  const element = document.createElement('a');

  const image = PRINT_BTN;
  element.innerHTML = image;
  element.addEventListener('click', () => {
    window.open(that.serverConstants.CITIZEN_API_URL+"/getFile/"+params.data.path,"_blank");
  });
  element.addEventListener('keydown', (event) => {
    if(event.keyCode == 13 || event.keyCode == 32){
      window.open(that.serverConstants.CITIZEN_API_URL+"/getFile/"+params.data.path,"_blank");
    }
    else if(event.keyCode == 9){
      event.preventDefault();
      setTimeout(() => deleteElement.focus(), 0);
    }

  });
  element.setAttribute("tabindex", "0");
  const divRow = document.createElement('div');
  divRow.setAttribute("class", "row");
  const divCol1 = document.createElement('div');
  divCol1.setAttribute("class", "col-3");

  divCol1.appendChild(element);

  // Delete Button
  const deleteElement = document.createElement('a');
  /*if (params.data.statusCd === "CO" || params.data.statusCd === "CN" || that.isDisabled) {
    deleteElement.setAttribute("class", "disabled");
  }*/

  deleteElement.innerHTML = DELETE_BTN;
  deleteElement.addEventListener('click', () => {
    that.deleteData = params.data;
    var modal = document.getElementById("myModal");
      modal.style.display = "block";
  });

  deleteElement.addEventListener('keydown', (event) => {
    if(event.keyCode == 13 || event.keyCode == 32){
      that.deleteData = params.data;
      var modal = document.getElementById("myModal");
      modal.style.display = "block";
    }
    else if(event.keyCode == 9){
      event.preventDefault();
    }
  });

  deleteElement.setAttribute("tabindex", "0");
  const divCol2 = document.createElement('div');
  divCol2.setAttribute("class", "col-2");
  divCol2.appendChild(deleteElement);

  //Audit Button
  
  const divCol3 = document.createElement('div');
  divCol3.setAttribute("class", "col-1");
  divRow.appendChild(divCol1);
  if(that.dataService.getSharedDataObject().get("roles")[0].id == 4){
    divRow.appendChild(divCol2);
  }
  return divRow;
}
deleteFile(){
  this.http.post(this.serverConstants.CITIZEN_API_URL+'/documents/save',this.deleteData).subscribe((data)=>{
    if(data["message"] == 'success'){
      this.toastService.success("File deleted successfully","My Documents");
      this.load();
      this.closeModal();
    }
    else{
      this.closeModal();
      this.toastService.error("'Record not saved: Please review or contact Help Desk", "My Documents");
    }
  },error=>{
    this.closeModal();
    this.toastService.error("'Record not saved: Please review or contact Help Desk", "My Documents");
  })
}
closeModal(){
  var modal = document.getElementById("myModal");
  modal.style.display = "none";
}

}



// WEBPACK FOOTER //
// ./src/app/upload/upload.component.ts